export class ObjectUtil {

  /**
   * Check if object is empty
   */
  static isEmpty(obj: any): boolean {
    if (
      obj && // 👈 null and undefined check
      Object.keys(obj).length === 0 &&
      Object.getPrototypeOf(obj) === Object.prototype
    ) {
      return true;
    }
    return false;
  }

  /**
   * Extract key and value
   */
  toMap(o: any) {
    const map = new Map<string, any>();
    for (const [key, value] of Object.entries(o)) {
      map.set(key, value);
    }
    return map;
  }

  /**
   * Extract key and value from object
   */
  toArrayMap(o: any) {
    const maps = [];
    for (const [key, value] of Object.entries(o)) {
      maps.push({ key, value });
    }
    return maps;
  }
}
